export default "__VITE_ASSET__Djc$P6Rz__"